export const buildOneDayPrompt = ({
  place,
  group,
  suggestions,
  weatherData,
  tripDate
}) => `
You are a professional travel writer creating a REALISTIC, up-to-date one-day travel itinerary.

Destination: ${place}
Duration: 1 day
Traveler Type: ${group}
${tripDate ? `Travel Date: ${tripDate}` : ""}

${weatherData
    ? `
Weather Conditions for that date:
- Temperature: ${weatherData.temperature}°C
- Condition: ${weatherData.condition}
- Wind Speed: ${weatherData.windSpeed} km/h

IMPORTANT:
Adapt the itinerary according to the weather.
If it is hot, reduce long outdoor walking in the afternoon.
If it is rainy, include indoor attractions or covered areas.
If it is cold, suggest warm indoor spots or cozy cafes.
If the weather is pleasant, include outdoor sightseeing and walking routes.
`
    : ""
  }

${suggestions ? `
Traveler preferences (blend naturally into the plan, do NOT list separately):
${Array.isArray(suggestions)
      ? suggestions.join(", ")
      : suggestions}
` : ""}

STYLE REQUIREMENTS:
- Write in a soft, human, and friendly tone.
- Tell the traveler clearly what to do (use action verbs like Visit, Walk, Explore, Try, Head to).
- Keep a light storytelling flow so Morning connects naturally to Afternoon and Evening.
- Use simple and easy English so anyone can understand.
- Keep the plan realistic and up-to-date with current travel trends and popular spots.
- Prefer places that are active, well-rated, and commonly visited.
- Avoid outdated or permanently closed attractions.
- Avoid dramatic or overly poetic language.
- Avoid robotic phrases like “start your day by”.
- Do NOT describe emotions deeply.
- Paragraphs only. No bullet points. No emojis.

STRICT OUTPUT FORMAT:

TITLE: ${place} One-Day Itinerary

DAY 1

## Morning
Write ONE clear paragraph (3–4 sentences).
End the paragraph by writing exactly:
Location: <Place Name>
at the very end of the same paragraph.

## Afternoon
Write ONE clear paragraph (3–4 sentences).
End the paragraph by writing exactly:
Location: <Place Name>
at the very end of the same paragraph.

## Evening
Write ONE clear paragraph (3–4 sentences).
End the paragraph by writing exactly:
Location: <Place Name>
at the very end of the same paragraph.

Estimated Budget: India: ₹ <min> - ₹ <max>
(Write on ONE line only. Exclude flights and hotels.)

## Transportation
Write ONE practical paragraph explaining how to move efficiently around ${place} in one day
(local transport apps, metro, autos, walking routes, taxis).

IMPORTANT:
Always write the location on a new line using exactly:
Location: Place Name

END
`;